import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/images/icon-x.svg';
import _imports_1 from '../assets/images/logo.svg';
import _imports_2 from '../assets/images/extension-metamask.svg';
import _imports_3 from '../assets/images/extension-coinbase.svg';
import _imports_4 from '../assets/images/extension-phanton.svg';
import _imports_5 from '../assets/images/icon-beta.svg';
import _imports_6 from '../assets/images/icon-chrome.svg';
import _imports_7 from '../assets/images/menu-user.svg';
import _imports_8 from '../assets/images/menu-copy.svg';
import _imports_9 from '../assets/images/menu-disconnect.svg';
import _imports_10 from '../assets/images/logo-s.svg';
const _hoisted_1 = {
  class: "report"
};
const _hoisted_2 = {
  class: "report-content"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "introduction"
}, "Submit potential cyber threat information such as scams and phishing sites.", -1);
const _hoisted_5 = {
  class: "cube",
  style: {
    "margin-bottom": "24px"
  }
};
const _hoisted_6 = {
  class: "cube"
};
const _hoisted_7 = {
  class: "login",
  id: "login"
};
const _hoisted_8 = {
  class: "login-wrap"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "introduction"
}, "Connect your wallet to revoke risky Approvals", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "extension disabled"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" Coinbase Wallet(Soon) ")], -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "extension disabled"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" Phantom(Soon) ")], -1);
const _hoisted_17 = {
  class: "dialog-menu"
};
const _hoisted_18 = {
  class: "dialog-menu-1"
};
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div><a class=\"link\" href=\"https://www.aegisweb3.com/\">Home</a></div><div><a class=\"link\" href=\"https://analyze.aegisweb3.com/\">Analyze</a></div><div><a class=\"link active\" href=\"/\">Revoke</a></div><div><a href=\"https://antirug.aegisweb3.com/\" class=\"link\"> Anti-Rug <img style=\"margin-top:-10px;\" src=\"" + _imports_5 + "\" alt=\"\"></a></div><div><a class=\"link\" href=\"https://www.aegisweb3.com/bot\">Bot</a></div><div><a href=\"https://chrome.google.com/webstore/detail/peckshieldalert/dakkielolpafjbgnjnakddabmbbkcioe\" target=\"_blank\" class=\"btn success\"><img src=\"" + _imports_6 + "\" alt=\"\"> Download </a></div>", 6);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1);
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1);
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
const _hoisted_29 = {
  class: "main"
};
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"header-left\"><a href=\"https://www.aegisweb3.com/\"><img src=\"" + _imports_1 + "\" class=\"logo\" alt=\"logo\"></a><div class=\"menu\"><a href=\"https://www.aegisweb3.com/\" class=\"menu-item\">Home</a><a href=\"https://analyze.aegisweb3.com/\" class=\"menu-item\">Analyze</a><a href=\"/\" class=\"menu-item active\">Revoke</a><a href=\"https://antirug.aegisweb3.com/\" class=\"menu-item\"> Anti-Rug <img style=\"margin-top:-10px;\" src=\"" + _imports_5 + "\" alt=\"\"></a><a href=\"https://www.aegisweb3.com/bot\" class=\"menu-item\">Bot</a></div></div>", 1);
const _hoisted_31 = {
  class: "header-right"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://chrome.google.com/webstore/detail/peckshieldalert/dakkielolpafjbgnjnakddabmbbkcioe",
  target: "_blank",
  class: "btn success"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" Download ")], -1);
const _hoisted_33 = {
  key: 1,
  href: "javascript:void(0)",
  class: "btn loggedin"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1);
const _hoisted_35 = {
  class: "logged-menu"
};
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1);
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1);
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1);
import { ElMessage } from 'element-plus';
import { reportBug } from '@/assets/js/api/index';
import { onMounted, onUnmounted, ref, reactive } from 'vue';
import { connectToMetamask, chkConnectToMetamask } from '@/assets/js/contract/connectMetamask';
import { setLoginState } from '@/assets/js/loginstate';
import showErrorMessage from '@/assets/js/error.js';
import { shortAddress, copy } from '@/assets/js/utils';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
export default {
  __name: 'MyHeader',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const showDialog = ref(false);
    const showLogin = ref(route?.query?.login == 'true' ? true : false);
    let timer = null;
    const form = reactive({
      type: '1',
      url: '',
      text: ''
    });
    if (route?.query?.report == 'true') {
      store.commit('setShowReport', true);
    }
    const handleReset = () => {
      form.type = '1';
      form.url = '';
      form.text = '';
    };
    const handleReport = () => {
      let type = form.type;
      let url = form.url.trim();
      let text = form.text.trim();
      if (url.length <= 0 && text.length <= 0) {
        return;
      }
      reportBug(type, url, text).then(() => {
        handleReset();
        store.commit('setShowReport', false);
        ElMessage.success('Submitted successfully');
      });
    };
    const handleShowDialog = (value, event) => {
      let id = event.target.id;
      if (value || !value && id == 'dialog') {
        showDialog.value = value;
      }
    };
    const handleConnected = () => {
      connectToMetamask('Metamask').then(arr => {
        if (arr.length <= 0) {
          return Promise.reject('No Address');
        } else {
          setLoginState(store, {
            address: arr[0].trim().toLowerCase(),
            extension: 'Metamask'
          });
        }
        showLogin.value = false;
        if (route?.query?.url) {
          window.location.href = route?.query?.url;
        }
      }).catch(err => {
        showErrorMessage(err);
      });
    };
    function logoutHandle() {
      setLoginState(store);
    }
    function handleSearch() {
      router.push(`/tokenapproval/${route?.params?.chain || 'eth'}/${store.state.address}`);
    }
    function startTimer() {
      timer = setInterval(() => {
        chkConnectToMetamask().then(arr => {
          if (arr.length <= 0) {
            logoutHandle();
          }
          if (store?.state?.address && arr[0] !== store.state.address) {
            setLoginState(store, {
              address: arr[0].trim().toLowerCase(),
              extension: 'Metamask'
            });
          }
        }).catch(err => {
          showErrorMessage(err, false);
        });
      }, 2000);
    }
    onMounted(() => {
      startTimer();
    });
    onUnmounted(() => {
      clearInterval(timer);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_ArrowDown = _resolveComponent("ArrowDown");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(" Report "), _createElementVNode("img", {
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = $event => _unref(store).commit('setShowReport', false)),
        alt: ""
      })]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createTextVNode(" Issue Type "), _createVNode(_component_el_select, {
        modelValue: form.type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.type = $event),
        placeholder: "Select",
        size: "large",
        style: {
          "width": "100%",
          "margin-top": "24px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "Scam/Phishing",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "Wrong label",
          value: "2"
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: form.url,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.url = $event),
        size: "large",
        placeholder: "Please enter a suspicious token contract or URL",
        style: {
          "width": "100%",
          "margin-top": "24px"
        }
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" Describe The Issue "), _createVNode(_component_el_input, {
        modelValue: form.text,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.text = $event),
        autosize: {
          minRows: 2,
          maxRows: 10
        },
        type: "textarea",
        placeholder: "Please describe a problem of the report",
        style: {
          "width": "100%",
          "margin-top": "24px"
        }
      }, null, 8, ["modelValue"])]), _createElementVNode("div", {
        class: "btns"
      }, [_createElementVNode("button", {
        class: "successBorderC",
        onClick: handleReset
      }, "Reset content"), _createElementVNode("button", {
        class: "success",
        onClick: handleReport
      }, "Submit")])])], 512), [[_vShow, _unref(store)?.state?.showReport]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("a", {
        href: "javascript:void",
        onClick: _cache[4] || (_cache[4] = $event => showLogin.value = false)
      }, _hoisted_12)]), _hoisted_13, _createElementVNode("div", {
        class: "extensions"
      }, [_createElementVNode("div", {
        class: "extension",
        onClick: handleConnected
      }, [_hoisted_14, _createTextVNode(" MetaMask ")]), _hoisted_15, _hoisted_16])])], 512), [[_vShow, showLogin.value]]), _createElementVNode("div", {
        class: _normalizeClass(["dialog", {
          show: showDialog.value
        }]),
        id: "dialog",
        onClick: _cache[6] || (_cache[6] = $event => handleShowDialog(false, $event))
      }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", null, [_createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: handleConnected,
        class: "btn"
      }, _toDisplayString(_unref(store)?.state?.address ? _unref(shortAddress)(_unref(store).state.address, 5, 5) : 'Connect Wallet'), 1)]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("a", {
        href: "javascript:void(0)",
        class: "action",
        onClick: handleSearch
      }, [_hoisted_25, _createTextVNode(" My Approvals ")], 512), [[_vShow, _unref(store)?.state?.address]])]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("a", {
        href: "javascript:void(0)",
        class: "action",
        onClick: _cache[5] || (_cache[5] = $event => _unref(copy)(_unref(store).state.address))
      }, [_hoisted_26, _createTextVNode(" Copy Addresses ")], 512), [[_vShow, _unref(store)?.state?.address]])]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("a", {
        href: "javascript:void(0)",
        class: "action",
        onClick: logoutHandle
      }, [_hoisted_27, _createTextVNode(" Disconnect ")], 512), [[_vShow, _unref(store)?.state?.address]])])]), _hoisted_28])], 2), _createElementVNode("header", null, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_hoisted_32, !_unref(store)?.state?.address ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "javascript:void(0)",
        onClick: _cache[7] || (_cache[7] = $event => showLogin.value = true),
        class: "btn"
      }, "Connect Wallet")) : (_openBlock(), _createElementBlock("a", _hoisted_33, [_hoisted_34, _createTextVNode(_toDisplayString(_unref(shortAddress)(_unref(store).state.address, 5, 5)) + " ", 1), _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
        _: 1
      }), _createElementVNode("div", _hoisted_35, [_createElementVNode("a", {
        class: "logged-menu-item",
        onClick: handleSearch
      }, [_hoisted_36, _createTextVNode(" My Approvals ")]), _createElementVNode("a", {
        class: "logged-menu-item",
        onClick: _cache[8] || (_cache[8] = $event => _unref(copy)(_unref(store).state.address))
      }, [_hoisted_37, _createTextVNode(" Copy Addresses ")]), _createElementVNode("a", {
        class: "logged-menu-item",
        onClick: logoutHandle
      }, [_hoisted_38, _createTextVNode(" Disconnect ")])])])), _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "mobile-menu",
        onClick: _cache[9] || (_cache[9] = $event => handleShowDialog(true, $event))
      })])])])], 64);
    };
  }
};